"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserProfile = void 0;
const react_1 = require("react");
/**
 * Gets a profile from cache or requests it from the relays
 */
function useUserProfile(system, pubKey) {
    return (0, react_1.useSyncExternalStore)(h => {
        if (pubKey) {
            system.ProfileLoader.TrackMetadata(pubKey);
        }
        const release = system.ProfileLoader.Cache.hook(h, pubKey);
        return () => {
            release();
            if (pubKey) {
                system.ProfileLoader.UntrackMetadata(pubKey);
            }
        };
    }, () => system.ProfileLoader.Cache.getFromCache(pubKey));
}
exports.useUserProfile = useUserProfile;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlVXNlclByb2ZpbGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvdXNlVXNlclByb2ZpbGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsaUNBQTZDO0FBRzdDOztHQUVHO0FBQ0gsU0FBZ0IsY0FBYyxDQUFDLE1BQW1CLEVBQUUsTUFBZTtJQUNqRSxPQUFPLElBQUEsNEJBQW9CLEVBQ3pCLENBQUMsQ0FBQyxFQUFFO1FBQ0YsSUFBSSxNQUFNLEVBQUU7WUFDVixNQUFNLENBQUMsYUFBYSxDQUFDLGFBQWEsQ0FBQyxNQUFNLENBQUMsQ0FBQztTQUM1QztRQUNELE1BQU0sT0FBTyxHQUFHLE1BQU0sQ0FBQyxhQUFhLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUUsTUFBTSxDQUFDLENBQUM7UUFDM0QsT0FBTyxHQUFHLEVBQUU7WUFDVixPQUFPLEVBQUUsQ0FBQztZQUNWLElBQUksTUFBTSxFQUFFO2dCQUNWLE1BQU0sQ0FBQyxhQUFhLENBQUMsZUFBZSxDQUFDLE1BQU0sQ0FBQyxDQUFDO2FBQzlDO1FBQ0gsQ0FBQyxDQUFBO0lBQ0gsQ0FBQyxFQUNELEdBQUcsRUFBRSxDQUFDLE1BQU0sQ0FBQyxhQUFhLENBQUMsS0FBSyxDQUFDLFlBQVksQ0FBQyxNQUFNLENBQUMsQ0FDdEQsQ0FBQztBQUNKLENBQUM7QUFoQkQsd0NBZ0JDIn0=